<cx-org-form i18nRoot="orgUser">
  <section main class="details custom first-form-section">
    @if (form) {
      <ng-container main [formGroup]="form">
        <label class="full-width">
          <span class="label-content required">
            <label>{{ 'orgUser.uid' | cxTranslate }}</label>
          </span>
          @if (!edit) {
            <div class="id-label-container">
              <span class="label-content">
                {{unitId}}-01-
              </span>
              <input
                type="text"
                class="form-control"
                required
                placeholder="{{ 'orgUser.uid' | cxTranslate }}"
                formControlName="uid"
                />
              </div>
            }
            @if (edit) {
              <span class="label-content">
                {{form?.value.uid}}
              </span>
            }
            <cx-form-errors [control]="form.get('uid')"></cx-form-errors>
          </label>
          <label>
            <span class="label-content required">{{
              'orgUser.title' | cxTranslate
            }}</span>
            <ng-select
              formControlName="titleCode"
              [searchable]="false"
              [clearable]="false"
              [items]="titles$ | async"
              bindLabel="name"
              bindValue="code"
              appendTo="body"
              [placeholder]="'orgUser.title' | cxTranslate"
              >
            </ng-select>
          </label>
          <label>
            <span class="label-content required">{{
              'orgUser.firstName' | cxTranslate
            }}</span>
            <input
              type="text"
              class="form-control"
              required
              placeholder="{{ 'orgUser.firstName' | cxTranslate }}"
              formControlName="firstName"
              />
              <cx-form-errors [control]="form?.get('firstName')"></cx-form-errors>
            </label>
            <input
              type="checkbox"
              hidden
              class="form-control"
              formControlName="edit"
              [(ngModel)]="edit"
              />
              <label>
                <span class="label-content required">{{
                  'orgUser.lastName' | cxTranslate
                }}</span>
                <input
                  type="text"
                  class="form-control"
                  required
                  placeholder="{{ 'orgUser.lastName' | cxTranslate }}"
                  formControlName="lastName"
                  />
                  <cx-form-errors [control]="form?.get('lastName')"></cx-form-errors>
                </label>
                <label>
                  <span class="label-content required">{{
                    'orgUser.email' | cxTranslate
                  }}</span>
                  <input
                    class="form-control"
                    type="email"
                    required
                    placeholder="{{ 'orgUser.email' | cxTranslate }}"
                    formControlName="email"
                    />
                    <cx-form-errors [control]="form?.get('email')"></cx-form-errors>
                  </label>
                  @if (deliveryData$ | async; as deliveryData) {
                    <div class="uig-user-form__input-container">
                      <label>
                        <span class="label-content required">{{
                          'orgUser.deliveryAddress' | cxTranslate
                        }}</span>
                        <ng-select
                          formControlName="shippingAddressPk"
                          [searchable]="false"
                          [clearable]="false"
                          [items]="deliveryData.deliveryAddresses"
                          bindLabel="formattedAddress"
                          bindValue="id"
                          appendTo="body"
                          [(ngModel)]="selectedDeliveryAddressId"
                          >
                        </ng-select>
                        <cx-form-errors [control]="form?.get('shippingAddressPk')"></cx-form-errors>
                      </label>
                      <label>
                        <span class="label-content required">{{
                          'orgUser.standardShippingMethod' | cxTranslate
                        }}</span>
                        <ng-select
                          class=""
                          formControlName="preferredDeliveryModeCode"
                          [searchable]="false"
                          [clearable]="false"
                          [items]="deliveryData.deliveryModes"
                          bindLabel="name"
                          bindValue="code"
                          appendTo="body"
                          [(ngModel)]="selectedDeliveryModeCode"
                          >
                        </ng-select>
                        <cx-form-errors [control]="form.get('preferredDeliveryModeCode')"></cx-form-errors>
                      </label>
                    </div>
                  }
                </ng-container>
              }
            </section>

            <section main class="details custom">
              @if (form) {
                <ng-container main [formGroup]="form">
                  @if (accessSubjectOverviewData$ | async; as accessSubjectOverviewData) {
                    <div class="uig-user-form__input-container">
                      <h5 class="heading">{{ 'orgUser.permission.title' | cxTranslate }}:</h5>
                      <fieldset aria-required="true" class="full-width" formArrayName="roles">
                        @for (item of accessSubjectOverviewData.ringfotoAccessSubjects; track item) {
                          <div class="property full-width">
                            <label>{{ item.name }}</label>
                            @if (item.multiplePermissions) {
                              @if (item.allowedPermissions) {
                                <fieldset class="row">
                                  @for (allowedPermission of item.allowedPermissions; track allowedPermission) {
                                    @if (addCheckboxPlaceholder(item.allowedPermissions[0])) {
                                      <label class="form-check col-6"></label>
                                    }
                                    <label class="form-check col-6">
                                      <input type="checkbox"
                                        class="form-check-input"
                                        [value]="allowedPermission.uid"
                                        [checked]="userRoles?.includes(allowedPermission.uid)"
                                        (change)="updateRoles($event)"
                                        [disabled]="form?.status === 'DISABLED'" />
                                        <span class="form-check-label">
                                          {{ allowedPermission.label }}
                                        </span>
                                      </label>
                                    }
                                  </fieldset>
                                }
                              } @else {
                                @if (form?.get('suiGenerisPermission'); as suiFormGroup) {
                                  <div [formGroup]="suiFormGroup">
                                    <ng-select
                                      formControlName="uid"
                                      [searchable]="false"
                                      [clearable]="false"
                                      [items]="item.allowedPermissions"
                                      bindLabel="label"
                                      bindValue="uid"
                                      appendTo="body"
                                      (change)="updateRoles($event, item.code)">
                                    </ng-select>
                                    <cx-form-errors [control]="suiFormGroup.get('uid')"></cx-form-errors>
                                  </div>
                                }
                              }
                            </div>
                          }
                        </fieldset>
                      </div>
                    }
                  </ng-container>
                }
              </section>
            </cx-org-form>
